import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import BaseChangePuzzle from './BaseChangePuzzle'

ReactDOM.render(<BaseChangePuzzle width = { 3 } singlePlayer />, document.getElementById('root'))


